// 반원 동작 메뉴 (docs/ux/draft-v3): 아래 바 바로 위에 납작한 반원.
// 곡선 = 모든 방 공통 동작(흰 유리, 이름표는 위), 직선 = 이 방·지금 상황 동작(진한 색, 이름표는 아래).
import { LINE } from './lineIcons';
import { el } from './shell';

export interface WheelItem { icon: keyof typeof LINE; label: string; click(): void; on?: boolean }

export interface Wheel {
  readonly open: boolean;
  show(common: WheelItem[], line: WheelItem[]): void;
  hide(): void;
}

export function createWheel(layer: HTMLElement): Wheel {
  const box = el('div', 'wheel');
  layer.append(box);
  let open = false, sig = '';
  const btn = (it: WheelItem, cls: string, x: number, y: number) => {
    const b = el('button', 'wb ' + cls + (it.on ? ' on' : ''), LINE[it.icon]);
    b.type = 'button';
    b.append(el('span', '', it.label));
    b.style.left = `calc(50% + ${x.toFixed(0)}px)`; b.style.top = y.toFixed(0) + 'px';
    b.addEventListener('click', (e) => { e.stopPropagation(); it.click(); });
    return b;
  };
  return {
    get open() { return open; },
    show(common, line) {
      open = true; box.classList.add('on');
      const s = common.map((c) => c.icon + c.label + !!c.on).join() + '|' + line.map((c) => c.icon + c.label + !!c.on).join();
      if (s === sig) return;
      sig = s; box.replaceChildren();
      const w = Math.min(box.clientWidth || 360, 380), r = w / 2 - 34, ry = 86;
      // 곡선: 직선과 만나는 양 끝은 비워 두고 36°~144°
      common.forEach((c, i) => { const a = Math.PI + (36 + i * (108 / Math.max(1, common.length - 1))) / 180 * Math.PI; box.append(btn(c, 'arc', Math.cos(a) * r, Math.sin(a) * ry)); });
      // 직선: 1~4개를 양 끝부터 고르게 (가운데가 비면 카피바라 쪽이 덜 가려진다)
      const n = line.length, xs = n === 1 ? [-r - 10] : n === 2 ? [-r - 10, r + 10] : n === 3 ? [-r - 10, 0, r + 10] : [-r - 10, -(r + 10) / 3, (r + 10) / 3, r + 10];
      line.forEach((c, i) => box.append(btn(c, 'room', xs[i] ?? 0, 0)));
    },
    hide() { open = false; sig = ''; box.classList.remove('on'); box.replaceChildren(); },
  };
}
